// Function to initialize Swiper for screens up to 700px
function initSwiper() {
    if (window.matchMedia("(max-width: 700px)").matches) {
        // Check if Swiper is already initialized to avoid reinitialization
        if (!document.querySelector('.swiper--top').swiper) {
            let SwiperTop = new Swiper('.swiper--top', {
                spaceBetween: 0,
                centeredSlides: true,
                speed: 7000,
                autoplay: {
                    delay: 0,
                },
                loop: true,
                slidesPerView: 'auto',
                allowTouchMove: false,
                disableOnInteraction: true
            });
        }
    }
}

// Initialize Swiper on page load
initSwiper();

// Reinitialize Swiper on window resize (if needed)
window.addEventListener('resize', function() {
    initSwiper();
});
